const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Render a server date without shifting the day. Two shapes arrive here and they need opposite
 * treatment:
 *
 *   'YYYY-MM-DD HH:MM:SS'  — a naive TO_CHAR string. Its digits ARE the wall clock, so they are
 *                            read straight off; parsing it would have the browser guess a zone.
 *   '...T18:30:00.000Z'    — an ISO instant, which is how a Date reaches us through JSON. Its
 *                            digits are UTC. The backend built it from a `timestamp without time
 *                            zone` column in the server's local zone, so the local parts are what
 *                            recover the stored wall clock. Reading UTC parts here printed the
 *                            previous day.
 *
 * Lives in its own module (not inside GrantAccessModal) because the /users table renders grant
 * dates too, and importing a modal for a date helper would drag the modal into that bundle.
 */
export function formatDate(value) {
  if (!value) return '—';

  const naive = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?)?$/);
  if (naive) return `${naive[3]} ${MONTHS[Number(naive[2]) - 1]} ${naive[1]}`;

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${String(d.getDate()).padStart(2, '0')} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export default formatDate;
